import { useTranslation } from 'react-i18next';

function Agreement({
  className = '',
  defaultValue = true,
  onAnswer = () => {},
}) {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <p>{ t('welcome and introduction') }</p>
      <p>
        <label>
          <input
            type="checkbox"
            onChange={(e) => {onAnswer(e.target.checked)}}
            defaultChecked={defaultValue}
          />
          <span>{ t('i agree') }</span>
        </label>
      </p>
    </div>
  )
}

export default Agreement;